import { ErrorMessageContents } from '../../../helpers/hub'
import { TickerInfo } from './types'

export const activityTickerFetch = () =>
  ({ type: 'activityticker.fetch' } as const)
type ActivityTickerFetchAction = ReturnType<typeof activityTickerFetch>

export const activityTickerFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'activityticker.fetchFail', payload: error, error: true } as const)
export type ActivityTickerFetchFailAction = ReturnType<
  typeof activityTickerFetchFail
>

export const getActivityTickerSuccess = (tickerInfo: TickerInfo[]) =>
  ({ type: 'activityticker.success', payload: tickerInfo } as const)
export type ActivityTickerSuccessAction = ReturnType<
  typeof getActivityTickerSuccess
>

export const unsubscribeFromTicker = () =>
  ({ type: 'activityticker.fetchCancel' } as const)
export type ActivityTickerFetchCancelAction = ReturnType<
  typeof unsubscribeFromTicker
>

export type ActivityTickerAction =
  | ActivityTickerFetchAction
  | ActivityTickerFetchFailAction
  | ActivityTickerFetchCancelAction
  | ActivityTickerSuccessAction
